/*
 * Copyright (c) 2023, WSO2 LLC (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { FormattedMessage } from 'react-intl';
import EmailIcon from 'components/ChoreoSystem/Icons/generated/Email';
import AuthenticateButton from 'components/ChoreoSystem/Authenticate/AuthenticateButton/AuthenticateButton';

interface EmailLoginButtonProps {
  onClick: () => void;
}

export default function EmailLoginButton(props: EmailLoginButtonProps) {
  const { onClick } = props;

  return (
    <AuthenticateButton
      testId="email-sign-in"
      onClick={onClick}
      startIcon={<EmailIcon fontSize="inherit" />}
    >
      <FormattedMessage
        id="modules.login.buttons.emailLoginButton.emailLoginButton.signin.withEmail"
        defaultMessage="Sign in with Email"
      />
    </AuthenticateButton>
  );
}
